
const PROJECTS = [["Memphis Grizzlies × TayKeith", "Cut & sew · Graphics · Sampling · Bulk · Freight"], ["NBA Program", "Cut & sew · Partnership · Bulk · Freight"], ["NBA YoungBoy × Guapi", "Trim · Technical · Sampling · Bulk · Freight"], ["PFW SS27 PAZ", "Runway · Design · Sampling · Custom fabrication"], ["NFL × Born X Raised", "Sampling · Bulk · Freight"], ["Campaign Production", "Creative direction · Photo · Video"], ["Dodge × Guapi", "Trim · Technical · Sampling · Bulk · Freight"], ["Bespoke Programs", "Design · Technical · Sampling · Custom fabrication"], ["NFL — Raiders", "Sampling · Bulk · Freight"], ["StreetMob Records — Campaign", "Creative direction · Photo · Video · Production"], ["Devin Haney — Fight Program", "Cut & sew · Sampling · Bulk · Screenprint · Freight"], ["Holiday — Accessories", "Accessories · Design · Sampling · Bulk"], ["Jermall Charlo — Fight Program", "Cut & sew · Graphics · Sampling · Bulk · Screenprint · Freight"]];
const COVERS = window.BRDG.covers;
/* ---------- router ---------- */
let introDone = false, lastView = 'work';
const viewStack = [];
function currentView() { const v = document.querySelector('.view.active'); return v ? v.id.replace('view-','') : 'home'; }
const ROUTES = { home:'/', story:'/pages/story', capabilities:'/pages/capabilities', solutions:'/pages/capabilities', work:'/pages/work', inquire:'/pages/inquire', parchive:'/pages/work',
  brand:'/pages/capabilities-brand', design:'/pages/capabilities-design', development:'/pages/capabilities-development', manufacturing:'/pages/capabilities-manufacturing',
  campaigns:'/pages/capabilities-campaigns', logistics:'/pages/capabilities-logistics', advisory:'/pages/capabilities-advisory', programs:'/pages/capabilities-programs' };
for (let i = 0; i < 13; i++) ROUTES['p' + i] = '/pages/work#p' + i;
function go(name, push) {
  const t = document.getElementById('view-' + name);
  if (!t) { if (ROUTES[name]) location.href = ROUTES[name]; return; }
  if (push !== false) { const c = currentView(); if (c !== name) viewStack.push(c); }
  document.querySelectorAll('.view').forEach(v => v.classList.remove('active'));
  t.classList.add('active');
  window.scrollTo(0, 0);
  if (name === 'story') { const sv = document.getElementById('view-story'); if (sv) setTimeout(() => countUp(sv), 250); }
  if (name === 'inquire') qRender(1);
  if (name === 'home' && introDone) { showLogoStill(); }
  const bt2 = document.getElementById('backtool');
  if (bt2) bt2.style.display = (name === 'home') ? 'none' : 'inline-flex';
  updateFx();
}
function goBack() { const prev = viewStack.pop(); if (!prev) { if (document.getElementById('view-home')) go('home', false); else location.href = '/'; return; } go(prev, false); }
document.querySelectorAll('[data-nav]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); go(el.dataset.nav); }));
document.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', goBack));

/* ---------- intro ---------- */
var iv = document.getElementById('introvid');
function showLogoStill() {
  if (!iv) return;
  try { iv.pause(); } catch(e) {}
  iv.style.display = 'none';
  const ps = document.getElementById('introposter');
  if (ps) ps.style.display = 'block';
}
var _seen = false;
try { _seen = sessionStorage.getItem('brdg_seen') === '1'; } catch(e) {}
if (iv && _seen) {
  introDone = true;
  document.body.classList.remove('intro-mode');
  document.body.classList.add('revealed');
  const ml0 = document.getElementById('mountlines'); if (ml0) ml0.classList.add('gone');
  showLogoStill();
} else if (iv) {

document.body.classList.add('booting');

const ml = document.getElementById('mountlines');
const bl = [...ml.children];
let bi = 0, bt = null;
function startLines(ms) { if (bt) clearInterval(bt); bt = setInterval(() => { if (bi < bl.length) bl[bi++].classList.add('show'); }, ms); }
iv.playbackRate = 2.4;
startLines(140);
setTimeout(() => { const c = document.querySelector('.scrollcue'); if (c) c.classList.add('cueshow'); }, 1000);
iv.addEventListener('loadedmetadata', () => startLines(Math.max(((iv.duration * 1000 / iv.playbackRate) - 500) / bl.length, 60)));
function endIntro() {
  try { sessionStorage.setItem('brdg_seen', '1'); } catch(e) {}
  clearInterval(bt);
  ml.classList.add('gone');
  document.body.classList.remove('intro-mode');
  document.body.classList.add('revealed');
}
iv.addEventListener('ended', () => { introDone = true; endIntro(); });
document.querySelector('.hero13').addEventListener('click', () => { if (document.body.classList.contains('intro-mode')) { introDone = true; endIntro(); } });
setTimeout(() => { if (!introDone) { introDone = true; endIntro(); } }, 5000);
iv.play().catch(() => {});
setTimeout(() => { if (!introDone && (iv.paused || iv.currentTime === 0)) { introDone = true; endIntro(); showLogoStill(); } }, 1600);
document.addEventListener('touchstart', () => iv.play().catch(() => {}), { once:true });


}
/* ---------- edge fx (bottom 15%) ---------- */
const ZONE = 0.15;
let ticking = false;
function updateFx() {
  ticking = false;
  const vh = innerHeight;
  document.querySelectorAll('.view.active .fx, .stmt13').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.bottom < -80 || r.top > vh + 80) return;
    const c = (r.top + r.bottom) / 2;
    let p = 1;
    if (c > vh * (1 - ZONE)) p = Math.max((vh - c) / (vh * ZONE), 0);
    el.style.setProperty('--p', p.toFixed(3));
  });
}
addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(updateFx); } }, { passive:true });
addEventListener('resize', updateFx);
updateFx();

/* ---------- solution circles ---------- */
(function(){
let anyMoved = false;
document.querySelectorAll('.svc-strip').forEach(strip => {
  let sAuto = true, sDrag = false, sx = 0, sl = 0;
  setInterval(() => { if (sAuto && !sDrag) strip.scrollLeft += 0.6; }, 16);
  strip.addEventListener('pointerdown', e => { sDrag = true; anyMoved = false; sAuto = false; sx = e.clientX; sl = strip.scrollLeft; });
  strip.addEventListener('pointermove', e => { if (sDrag) { const dx = e.clientX - sx; if (Math.abs(dx) > 6) anyMoved = true; if (anyMoved) strip.scrollLeft = sl - dx; } });
  addEventListener('pointerup', () => { sDrag = false; setTimeout(() => sAuto = true, 4000); });
});
document.querySelectorAll('.svc').forEach(a => a.addEventListener('click', () => { if (!anyMoved) go(a.dataset.target); }));
})();

/* ---------- solutions vertical drum ---------- */
(function(){
  const drum = document.getElementById('soldrum'); if (!drum) return;
  const items = [...drum.querySelectorAll('.sditem')];
  const STEP = 30, R = (innerWidth < 700 ? 205 : 300);
  let rot = 0, dragging = false, moved = false, sy = 0, srot = 0;
  function render() {
    items.forEach((it, i) => {
      const ang = i * STEP + rot, rad = ang * Math.PI / 180, vis = Math.cos(rad);
      it.style.transform = 'translateY(' + (Math.sin(rad) * R) + 'px) scale(' + (0.5 + 0.5 * Math.max(vis, 0)) + ')';
      it.style.opacity = vis > -0.05 ? (0.2 + 0.8 * Math.max(vis, 0)) : 0;
      it.style.zIndex = Math.round(100 + vis * 100);
    });
  }
  render();
  const page = drum.closest('.soldrumpage');
  page.addEventListener('pointerdown', e => { dragging = true; moved = false; sy = e.clientY; srot = rot; });
  page.addEventListener('pointermove', e => { if (dragging) { const dy = e.clientY - sy; if (Math.abs(dy) > 6) moved = true; if (moved) { rot = srot + dy * 0.3; render(); } } });
  addEventListener('pointerup', () => { if (dragging) { dragging = false; rot = Math.round(rot / STEP) * STEP; render(); } });
  page.addEventListener('wheel', e => { e.preventDefault(); rot -= e.deltaY * 0.1; render(); }, { passive:false });
  items.forEach(it => it.addEventListener('click', () => { if (!moved) go(it.dataset.target); }));
})();

/* ---------- work reel ---------- */
let centerI = 0;
(function(){
  const reel = document.getElementById('reel'); if (!reel) return;
  const tones = ['#15181a','#1a1518','#171a15','#101418','#181410','#141018','#181014','#101810','#141414'];
  PROJECTS.forEach((p, i) => {
    const it = document.createElement('div');
    it.className = 'ritem';
    it.innerHTML = '<div class="art" style="background-image:url(' + COVERS[i] + '); background-size:cover; background-position:center; color:transparent"></div><div class="rmid">' + p[0] + '</div>';
    it.addEventListener('click', () => { if (moved) return; if (i === centerI) openProject(i, 'work'); else { rot = -i * STEP; render(); } });
    reel.appendChild(it);
  });
  const STEP = 34, R = (innerWidth < 700 ? 258 : 340);
  let rot = 0, vel = 0, dragging = false, moved = false, sy = 0, srot = 0;
  const nameEl = document.getElementById('reelname');
  function calcCenter() {
    let best = 0, bd = 1e9;
    PROJECTS.forEach((p, i) => { const a = Math.abs(((i * STEP + rot) % 360 + 540) % 360 - 180); const d = Math.min(a, 360 - a); if (d < bd) { bd = d; best = i; } });
    centerI = best;
  }
  function render() {
    [...reel.children].forEach((it, i) => {
      const ang = i * STEP + rot, rad = ang * Math.PI / 180, vis = Math.cos(rad);
      it.style.transform = 'translateY(' + (Math.sin(rad) * R) + 'px) rotateX(' + (-ang) + 'deg) scale(' + (0.72 + 0.28 * Math.max(vis, 0)) + ')';
      it.style.opacity = vis > -0.05 ? (0.15 + 0.85 * Math.max(vis, 0)) : 0;
      it.style.zIndex = Math.round(100 + vis * 100);
    });
    calcCenter();
    nameEl.textContent = PROJECTS[centerI][0];
  }
  (function loop() {
    if (!dragging && Math.abs(vel) > 0.02) { rot += vel; vel *= 0.94; render(); }
    else if (!dragging && vel !== 0 && Math.abs(vel) <= 0.02) { vel = 0; rot = Math.round(rot / STEP) * STEP; render(); }
    requestAnimationFrame(loop);
  })();
  const page = reel.closest('.reelpage');
  const archOn2 = () => document.getElementById('archreel').style.display !== 'none';
  page.addEventListener('pointerdown', e => { if (archOn2()) return; dragging = true; moved = false; sy = e.clientY; srot = rot; vel = 0; });
  page.addEventListener('pointermove', e => { if (dragging) { const dy = e.clientY - sy; if (Math.abs(dy) > 6) moved = true; if (moved) { const nr = srot + dy * 0.3; vel = nr - rot; rot = nr; render(); } } });
  addEventListener('pointerup', () => { if (dragging) { dragging = false; if (Math.abs(vel) < 0.5) { rot = Math.round(rot / STEP) * STEP; render(); } } });
  page.addEventListener('wheel', e => { e.preventDefault(); if (archOn2()) return; vel += e.deltaY * 0.02; }, { passive:false });
  render();
  window._workRender = render;
})();

/* ---------- solution-page project wheels ---------- */
document.querySelectorAll('[data-wheel]').forEach(wheel => {
  const drum = wheel.querySelector('.drum');
  const viewEl = wheel.closest('.view');
  const viewName = viewEl ? viewEl.id.replace('view-','') : 'work';
  PROJECTS.forEach((p, i) => {
    const it = document.createElement('div');
    it.className = 'witem';
    it.innerHTML = '<div class="wl">' + p[0] + '</div>';
    it.addEventListener('click', () => { if (!wheel._moved) openProject(i, viewName); });
    drum.appendChild(it);
  });
  const STEP = 28, R = (innerWidth < 700 ? 205 : 300);
  wheel._rot = 0; wheel._moved = false;
  function render() {
    [...drum.children].forEach((it, i) => {
      const ang = i * STEP + wheel._rot, rad = ang * Math.PI / 180, vis = Math.cos(rad);
      it.style.transform = 'translateY(' + (Math.sin(rad) * R) + 'px) rotateX(' + (-ang) + 'deg) scale(' + (0.7 + 0.3 * Math.max(vis, 0)) + ')';
      it.style.opacity = vis > -0.15 ? (0.25 + 0.75 * Math.max(vis, 0)) : 0;
      it.style.zIndex = Math.round(100 + vis * 100);
      it.style.pointerEvents = vis > 0.5 ? 'auto' : 'none';
    });
  }
  render();
  let dragging = false, sy = 0, srot = 0;
  wheel.addEventListener('pointerdown', e => { dragging = true; wheel._moved = false; sy = e.clientY; srot = wheel._rot; });
  wheel.addEventListener('pointermove', e => { if (dragging) { const dy = e.clientY - sy; if (Math.abs(dy) > 6) wheel._moved = true; if (wheel._moved) { wheel._rot = srot + dy * 0.25; render(); } } });
  addEventListener('pointerup', () => { if (dragging) { dragging = false; wheel._rot = Math.round(wheel._rot / STEP) * STEP; render(); } });
  wheel.addEventListener('wheel', e => { e.preventDefault(); wheel._rot -= e.deltaY * 0.12; render(); }, { passive:false });
});

/* ---------- project sheet ---------- */
let curProj = 0, curArch = 0;
function projStep(d) { curProj = (curProj + d + PROJECTS.length) % PROJECTS.length; openProject(curProj, lastView); }
function archStep(d) { curArch = (curArch + d + ARCHCATS.length) % ARCHCATS.length; const c = ARCHCATS[curArch]; if (c[0] === 'Headwear') openArchive('Headwear', HEADWEAR); else if (c[0] === 'Creative') openArchive('Creative', CREATIVE); else openArchive(c[0], []); }
function openProject(i, fromView) {
  curProj = i;
  lastView = fromView || 'work';
  document.getElementById('pj-title').textContent = PROJECTS[i][0];
  const cv2 = document.getElementById('pj-cover'); cv2.textContent = ''; cv2.style.backgroundImage = 'url(' + COVERS[i] + ')';
  const po = document.getElementById('pj-out');
  if (po && typeof POUT !== 'undefined') { const v = POUT[i] || ''; po.textContent = v ? 'Outcome — ' + v : ''; po.style.display = v ? 'block' : 'none'; }
  const pd = document.getElementById('pj-desc'); if (pd && typeof PSTMT !== 'undefined') pd.textContent = PSTMT[i] || '';
  const pt = document.getElementById('pj-tags');
  if (pt && typeof PTAGS !== 'undefined') { pt.innerHTML = ''; (PTAGS[i] || []).forEach(s => { const t = document.createElement('span'); t.className = 'stag'; t.textContent = s; pt.appendChild(t); }); }
  go('project');
}

/* ---------- quiz (branching) ---------- */
let QUEUE = [], QIDX = 0;
function qSteps() { return 3 + QUEUE.length + 1; }
function qTrackRender(pos) {
  const track = document.getElementById('qtrack');
  const total = Math.max(qSteps(), 5);
  track.querySelectorAll('span').forEach(s => s.remove());
  const num = document.getElementById('qnum');
  for (let i = 0; i < total; i++) {
    const s = document.createElement('span'); s.innerHTML = '<i></i>';
    if (pos > total || i < pos - 1) s.classList.add('done');
    else if (i === pos - 1) s.classList.add('cur');
    track.insertBefore(s, num);
  }
  num.textContent = ('0' + Math.min(pos, total)).slice(-2) + ' / ' + ('0' + total).slice(-2);
}
function qShow(q) {
  document.querySelectorAll('.qstep').forEach(s => s.classList.remove('active'));
  const el = document.querySelector('.qstep[data-q="' + q + '"]');
  if (el) el.classList.add('active');
}
function qRender(n) {
  QUEUE = []; QIDX = 0; qShow(n); qTrackRender(n);
  const bi2 = document.getElementById('qbuildinfo'); if (bi2) bi2.style.display = 'none';
  const bn2 = document.getElementById('qbuildnext'); if (bn2) bn2.style.display = 'none';
}
function qGo(n) { qShow(n); qTrackRender(n); }
function qBuild(el) {
  [...el.parentElement.children].forEach(c => c.classList.remove('on'));
  el.classList.add('on');
  document.getElementById('qbuildinfo').style.display = 'grid';
  document.getElementById('qbuildnext').style.display = 'inline-block';
}
const BRANCH_Q = {
  std:      { t:'Expected Budget', o:['$20,000 – $75,000','$75,000 – $150,000','$150,000 – $250,000','$250,000 +'] },
  campaign: { t:'Expected Budget', o:['$10,000 – $30,000','$30,000 – $50,000','$50,000 – $100,000','$100,000 +'] },
  pallets:  { t:'Estimated shipment size', o:['1–5 pallets','6–15 pallets','16–28 pallets','28 pallets +','N/A'] },
  engage:   { t:'How long is the engagement?', o:['Strategy Session','Strategy Sprint','Project Advisory','Monthly Advisory','Fractional Creative Leadership'] }
};
function qBranch() {
  const sel = [...document.querySelectorAll('.qstep[data-q="3"] .qopt.on')].map(e => e.dataset.k);
  QUEUE = [];
  const money = sel.filter(k => ['design','devmanuf','campaign','az','notsure'].includes(k));
  if (money.length === 1 && money[0] === 'campaign') QUEUE.push('campaign');
  else if (money.length > 0) QUEUE.push('std');
  if (sel.length === 1 && sel[0] === 'logistics') QUEUE.push('pallets');
  if (sel.includes('consulting')) QUEUE.push('engage');
  if (QUEUE.length === 0) QUEUE.push('std');
  QIDX = 0;
  qDynShow();
}
function qDynShow() {
  if (QIDX >= QUEUE.length) { qShow(5); qTrackRender(3 + QUEUE.length + 1); return; }
  const q = BRANCH_Q[QUEUE[QIDX]];
  document.getElementById('qdyn-title').textContent = q.t;
  const box = document.getElementById('qdyn-opts');
  box.innerHTML = '';
  q.o.forEach(op => {
    const d = document.createElement('div');
    d.className = 'qopt'; d.textContent = op;
    d.onclick = () => { [...box.children].forEach(c => c.classList.remove('on')); d.classList.add('on'); (window._qAns || (window._qAns = {}))[q.t + (QUEUE[QIDX] ? ' [' + QUEUE[QIDX] + ']' : '')] = op; setTimeout(() => { QIDX++; qDynShow(); }, 320); };
    box.appendChild(d);
  });
  qShow(4);
  qTrackRender(3 + QIDX + 1);
}
function qDynBack() { if (QIDX > 0) { QIDX--; qDynShow(); } else qGo(3); }
function qPick(el, next) { [...el.parentElement.children].forEach(c => c.classList.remove('on')); el.classList.add('on'); setTimeout(() => qGo(next), 350); }
(function(){ const ring = document.getElementById('qring'); if (!ring) return;
  for (let i = 0; i < 10; i++) { const d = document.createElement('i');
    const a = (i / 10) * Math.PI * 2; d.style.left = (50 + 49.5 * Math.cos(a)) + '%'; d.style.top = (50 + 49.5 * Math.sin(a)) + '%'; ring.appendChild(d); } })();

/* ---------- story countup ---------- */
let counted = false;
function countUp(root) {
  (root || document).querySelectorAll('.cnt').forEach(el => {
    const target = +el.dataset.n, t0 = performance.now(), dur = 900;
    const chip = el.closest(".schip, .pod"); if (chip) { chip.classList.remove("sweep"); void chip.offsetWidth; chip.classList.add("sweep"); }
    (function tick(t) {
      const k = Math.min((t - t0) / dur, 1);
      const v = Math.round(target * (1 - Math.pow(1 - k, 3)));
      el.textContent = el.dataset.plain ? String(v) : v.toLocaleString();
      if (k < 1) requestAnimationFrame(tick);
    })(t0);
  });
}

/* ---------- atoms: bottom 15% ---------- */
const cv = document.getElementById('dust'), ctx = cv.getContext('2d');
let W, H, parts = [];
function sizeCv() { W = cv.width = innerWidth * devicePixelRatio; H = cv.height = innerHeight * devicePixelRatio; cv.style.width = innerWidth + 'px'; cv.style.height = innerHeight + 'px'; }
sizeCv(); addEventListener('resize', sizeCv);
for (let i = 0; i < 60; i++) parts.push({ x:Math.random(), y:1 - Math.random() * 0.15, vy:-(0.00015 + Math.random() * 0.0004), vx:(Math.random() - .5) * 0.0002, r:(0.6 + Math.random() * 1.4) * devicePixelRatio, a:0.05 + Math.random() * 0.15 });
let lastY = scrollY, boost = 0;
addEventListener('scroll', () => { boost = Math.min(Math.abs(scrollY - lastY) / 60, 3); lastY = scrollY; }, { passive:true });
(function loop() {
  ctx.clearRect(0, 0, W, H);
  const sp = 1 + boost; boost *= 0.94;
  parts.forEach(p => {
    p.y += p.vy * sp * 16; p.x += p.vx * 16;
    if (p.y < 0.85) p.y = 1;
    if (p.x > 1.02) p.x = -0.02; if (p.x < -0.02) p.x = 1.02;
    ctx.globalAlpha = p.a * Math.max((p.y - 0.85) / 0.15, 0);
    ctx.fillStyle = '#f2f0ea';
    ctx.beginPath(); ctx.arc(p.x * W, p.y * H, p.r, 0, 7); ctx.fill();
  });
  requestAnimationFrame(loop);
})();

/* ===== v22: galleries, lightbox, cue hide ===== */
const GALLERIES = window.BRDG.galleries;
const YGBVID = window.BRDG.ygbvid;
const _openProject = openProject;
openProject = function(i, fromView) {
  _openProject(i, fromView);
  const g = document.getElementById('pj-gallery');
  g.innerHTML = '';
  const list = GALLERIES[String(i)];
  if (list && list.length) {
    list.forEach((u, k) => {
      const img = document.createElement('img');
      img.src = u; img.draggable = false;
      img.addEventListener('click', () => openLightbox(list, k));
      g.appendChild(img);
    });
  } else {
    for (let k = 1; k <= 3; k++) { const d = document.createElement('div'); d.className = 'imgbox mb'; d.textContent = '[ PHOTO 0' + k + ' ]'; g.appendChild(d); }
  }
  if (i === 2 && YGBVID) { const v = document.createElement('video'); v.src = YGBVID; v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true; v.style.cssText = 'width:100%;display:block;margin-bottom:4px;border-radius:2px'; g.appendChild(v); }
};
let LB = { list: [], idx: 0 };
function openLightbox(list, idx) {
  LB.list = list; LB.idx = idx;
  document.getElementById('lbimg').src = list[idx];
  const _w = String(list.length).length > 2 ? 3 : 2; document.getElementById('lbcount').textContent = String(idx + 1).padStart(_w, '0') + ' / ' + String(list.length).padStart(_w, '0');
  document.getElementById('lightbox').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function lbNav(d) { LB.idx = (LB.idx + d + LB.list.length) % LB.list.length; openLightbox(LB.list, LB.idx); }
function lbClose() { document.getElementById('lightbox').classList.remove('open'); document.body.style.overflow = ''; }
document.addEventListener('keydown', e => {
  if (!document.getElementById('lightbox').classList.contains('open')) return;
  if (e.key === 'ArrowRight') lbNav(1); if (e.key === 'ArrowLeft') lbNav(-1); if (e.key === 'Escape') lbClose();
});
(function(){
  const lb = document.getElementById('lightbox');
  lb.addEventListener('contextmenu', e => e.preventDefault());
  let sx = null;
  lb.addEventListener('pointerdown', e => sx = e.clientX);
  lb.addEventListener('pointerup', e => { if (sx !== null && Math.abs(e.clientX - sx) > 40) lbNav(e.clientX < sx ? 1 : -1); sx = null; });
})();
/* cue hides once you scroll */
addEventListener('scroll', () => {
  const c = document.querySelector('.scrollcue');
  if (c) c.classList.toggle('cuehide', scrollY > 50);
}, { passive: true });


/* ===== v23: product archive ===== */
const ARCHCATS = [["Headwear", true], ["Apparel", false], ["Accessories", false], ["Packaging", false], ["Creative", true]];
const CREATIVE = window.BRDG.creative;
const HEADWEAR = window.BRDG.headwear;
function workMode(m) {
  const $ = id => document.getElementById(id);
  if (!$('reel')) return;
  $('reel').style.display = m === 'projects' ? '' : 'none';
  if ($('archreel')) $('archreel').style.display = m === 'archive' ? '' : 'none';
  if ($('wb-projects')) $('wb-projects').classList.toggle('on', m === 'projects');
  if ($('reelname')) $('reelname').textContent = m === 'archive' ? ARCHCATS[0][0] : PROJECTS[0][0];
}
(function(){
  const reel = document.getElementById('archreel'); if (!reel) return;
  const STEP = 40, R = (innerWidth < 700 ? 212 : 320);
  let rot = 0, vel = 0, dragging = false, moved = false, sy = 0, srot = 0;
  const archOn = () => reel.style.display !== 'none';
  ARCHCATS.forEach((c, i) => {
    const it = document.createElement('div');
    it.className = 'ritem';
    const artmap = { 'Headwear': HEADWEAR[0], 'Creative': CREATIVE[0] };
    const bg = artmap[c[0]] ? 'background-image:url(' + artmap[c[0]] + '); background-size:cover; background-position:center;' : 'background:repeating-linear-gradient(45deg,#101010,#101010 14px,#151515 14px,#151515 28px);';
    it.innerHTML = '<div class="art" style="' + bg + '"></div><div class="rmid">' + c[0] + '</div>';
    it.addEventListener('click', () => { if (moved) return; if (i !== archCenter()) { vel = 0; rot = -i * STEP; render(); return; } if (c[0] === 'Headwear') openArchive('Headwear', HEADWEAR); else if (c[0] === 'Creative') openArchive('Creative', CREATIVE); else openArchive(c[0], []); });
    reel.appendChild(it);
  });
  function archCenter() {
    let best = 0, bd = 1e9;
    ARCHCATS.forEach((c, i) => { const a = Math.abs(((i * STEP + rot) % 360 + 540) % 360 - 180); const d = Math.min(a, 360 - a); if (d < bd) { bd = d; best = i; } });
    return best;
  }
  function render() {
    [...reel.children].forEach((it, i) => {
      const ang = i * STEP + rot, rad = ang * Math.PI / 180, vis = Math.cos(rad);
      it.style.transform = 'translateY(' + (Math.sin(rad) * R) + 'px) rotateX(' + (-ang) + 'deg) scale(' + (0.72 + 0.28 * Math.max(vis, 0)) + ')';
      it.style.opacity = vis > -0.05 ? (0.15 + 0.85 * Math.max(vis, 0)) : 0;
      it.style.zIndex = Math.round(100 + vis * 100);
    });
    const nm = document.getElementById('reelname');
    if (archOn()) nm.textContent = ARCHCATS[archCenter()][0];
  }
  render();
  (function loop() {
    if (!dragging && Math.abs(vel) > 0.02) { rot += vel; vel *= 0.94; render(); }
    else if (!dragging && vel !== 0 && Math.abs(vel) <= 0.02) { vel = 0; rot = Math.round(rot / STEP) * STEP; render(); }
    requestAnimationFrame(loop);
  })();
  const page = reel.closest('.reelpage');
  page.addEventListener('pointerdown', e => { if (!archOn()) return; dragging = true; moved = false; sy = e.clientY; srot = rot; vel = 0; });
  page.addEventListener('pointermove', e => { if (dragging) { const dy = e.clientY - sy; if (Math.abs(dy) > 6) moved = true; if (moved) { const nr = srot + dy * 0.3; vel = nr - rot; rot = nr; render(); } } });
  addEventListener('pointerup', () => { if (dragging) { dragging = false; if (Math.abs(vel) < 0.5) { rot = Math.round(rot / STEP) * STEP; render(); } } });
  page.addEventListener('wheel', e => { e.preventDefault(); if (!archOn()) return; vel += e.deltaY * 0.02; }, { passive:false });
})();
function openArchive(title, list) {
  curArch = ARCHCATS.findIndex(c => c[0] === title); if (curArch < 0) curArch = 0;
  document.getElementById('ar-title').textContent = title;
  const DESCS = {
    'Headwear': 'Custom caps, snapbacks, trucker hats, and knit beanies — designed, sampled, and produced across the BR-DG® factory network.',
    'Apparel': 'Cut & sew across every garment class — outerwear, fleece, knits, tees, jerseys, and denim — from first pattern to bulk.',
    'Accessories': 'Belts, eyewear, totes, and hardgoods — the objects that finish a program.',
    'Packaging': 'Rigid boxes, trims, labels, and hangtags — finished-goods thinking down to the unboxing.',
    'Creative': 'A history of shoots — campaign, e-commerce, and motion production directed in-house by BR-DG®.'
  };
  document.getElementById('ar-desc').textContent = DESCS[title] || 'Imagery being organized.';
  const g = document.getElementById('ar-gallery');
  g.innerHTML = '';
  if (list.length) list.forEach((u, k) => { const img = document.createElement('img'); img.src = u; img.draggable = false; img.addEventListener('click', () => openLightbox(list, k)); g.appendChild(img); });
  else for (let k = 1; k <= 6; k++) { const d = document.createElement('div'); d.className = 'imgbox mb'; d.textContent = '[ COMING SOON ]'; g.appendChild(d); }
  go('archivecat');
}


/* ===== v32: parallax drift — home & story ===== */
(function(){
  const els = [];
  const F = [0.08, 0.13, 0.10, 0.07, 0.09, 0.09];
  window._parRegister = (el, f) => { el.dataset.par = '1'; el._pf = f; els.push(el); };
  const _PSEL = innerWidth < 700 ? '#view-home .podgrid' : '#view-home .podgrid, #view-home .svc-strip, #view-story .glowpod, #view-story .statchips, #view-story .ptable';
  document.querySelectorAll(_PSEL).forEach((el, i) => {
    if (el.style.transform) return;
    el.dataset.par = '1'; el._pf = F[i % F.length]; els.push(el);
  });
  function apply() {
    const vh = innerHeight;
    els.forEach(el => {
      const v = el.closest('.view');
      if (v && !v.classList.contains('active')) { el.style.removeProperty('--par'); el._py = 0; return; }
      const r = el.getBoundingClientRect();
      if (r.width === 0) return;
      const cur = el._py || 0;
      const cc = (r.top - cur) + r.height / 2 - vh / 2;
      const y = Math.max(-38, Math.min(38, -cc * el._pf));
      el._py = y;
      el.style.setProperty('--par', y.toFixed(1) + 'px');
    });
  }
  addEventListener('scroll', () => requestAnimationFrame(apply), { passive:true });
  addEventListener('resize', apply);
  window._parApply = apply;
  apply();
})();

/* ===== shopify: quiz submit via contact form ===== */
function qSubmit() {
  const f = document.getElementById('brdg-contact-form') || document.querySelector('form[action*="/contact"]');
  const g = sel => [...document.querySelectorAll(sel)];
  const p1 = g('.qstep[data-q="1"] input').map(i => i.value.trim());
  const build = g('.qstep[data-q="2"] .qopt.on').map(e => e.textContent.trim()).join(', ');
  const details = (document.querySelector('#qbuildinfo input') || {value:''}).value.trim();
  const scope = g('.qstep[data-q="3"] .qopt.on').map(e => e.textContent.trim()).join(', ');
  const day = (document.getElementById('qday')||{value:''}).value, time = (document.getElementById('qtime')||{value:''}).value;
  const dyn = window._qAns ? Object.entries(window._qAns).map(([k,v]) => k.replace(/ \[.*\]$/,'') + ': ' + v).join('\n') : '';
  const body = ['BR-DG INQUIRY','','Name: ' + (p1[0]||''), 'Company: ' + (p1[1]||''), 'Email: ' + (p1[2]||''), 'Phone: ' + (p1[3]||''),'',
    'Building: ' + build, details ? 'Details: ' + details : '', 'Scope: ' + scope, dyn, '', 'Call request: ' + day + ' @ ' + time].filter(Boolean).join('\n');
  if (f) {
    const set = (n, v) => { const el = f.querySelector('[name="' + n + '"]'); if (el) el.value = v; };
    set('contact[name]', p1[0] || 'BR-DG Inquiry'); set('contact[email]', p1[2] || 'noreply@br-dg.agency');
    set('contact[phone]', p1[3] || ''); set('contact[body]', body);
    f.submit();
  } else { qShow(6); qTrackRender(99); }
}
/* ===== shopify: per-page boot ===== */
(function(){
  const bt = document.getElementById('backtool');
  if (bt && !document.getElementById('view-home')) bt.style.display = 'inline-flex';
  const av = document.querySelector('.view.active');
  if (av && av.id === 'view-story') setTimeout(() => countUp(av), 500);
  if (av && av.id === 'view-inquire') qRender(1);
  if (window.BRDG_POSTED) { qShow(6); qTrackRender(99); }
  setTimeout(() => {
    if (!location.hash) return;
    const h = location.hash.slice(1);
    if (document.getElementById('view-' + h)) go(h, false);
    else if (/^p\d+$/.test(h) && document.getElementById('view-work')) { openProject(+h.slice(1), 'work'); }
    else if (typeof SOLKEYS !== 'undefined' && SOLKEYS.indexOf(h) >= 0 && document.getElementById('solreader')) { go('solutions', false); enterReader(SOLKEYS.indexOf(h)); }
  }, 0);
  if (typeof _parApply === 'function') _parApply();
})();

/* ===== v35: home stats count when scrolled into view ===== */
(function(){
  const pg = document.querySelector('#view-home .podgrid');
  if (!pg) return;
  if (!('IntersectionObserver' in window)) { countUp(pg); return; }
  const io = new IntersectionObserver(es => { es.forEach(e => { if (e.isIntersecting) { countUp(pg); io.disconnect(); } }); }, { threshold: 0.3 });
  io.observe(pg);
})();

/* ===== v36: mobile folder menu ===== */
(function(){
  const f = document.getElementById('mfold');
  if (!f) return;
  /* v51: while the folder menu is open, the mobile sort button slides below it */
  window._syncSort = function(){
    const ps = document.getElementById('pasort'); if (!ps) return;
    const nav = document.querySelector('nav.pills');
    if (document.body.classList.contains('mnav-open') && innerWidth <= 640 && nav) {
      document.body.classList.remove('pasort-open');
      ps.style.top = (nav.offsetTop + nav.offsetHeight + 14) + 'px';
    } else { ps.style.top = ''; }
  };
  const closeNav = () => { document.body.classList.remove('mnav-open'); _syncSort(); };
  f.addEventListener('click', e => { e.stopPropagation(); document.body.classList.toggle('mnav-open'); _syncSort(); });
  document.querySelectorAll('nav.pills a').forEach(a => a.addEventListener('click', closeNav));
  document.addEventListener('click', e => { if (document.body.classList.contains('mnav-open') && !e.target.closest('nav.pills') && !e.target.closest('#mfold')) closeNav(); });
})();

/* ===== v49: product archive — 7 labeled sections with copy ===== */
(function(){
  const grid = document.getElementById('pagrid');
  if (!grid || !window.BRDG || !BRDG.parchive) return;
  const COPY = {"Headwear": "Headwear development and production. 5-panel, 6-panel, trucker, beanies, bucket hats, and custom crowns. Pattern, sample, and bulk manufacturing through vetted factories overseas and in Los Angeles.", "Outerwear": "Cut-and-sew outerwear. Coaches jackets, bombers, workwear, varsity, insulated, and technical shells. Developed from tech pack through production with fit and fabric standards.", "Bottoms": "Cut-and-sew bottoms — sweatpants, cargos, denim, shorts, and tailored trousers. Pattern making, fit engineering, grading and bulk production across woven and knit constructions.", "Hoodies": "Custom fleece and French terry hoodie manufacturing — heavyweight, garment-dyed, boxy and cropped fits. Embroidery, screenprint, puff, and appliqué. Manufactured overseas and in Los Angeles.", "Jerseys": "Jersey development and production — basketball, football, baseball, hockey, soccer and warmups. Mesh, tackle twill, sublimation, embroidery and heat-applied numbering, built for team programs, licensed collections and retail drops.", "Shirts": "T-shirt and woven shirt production — heavyweight cotton, boxy fits, button-downs, camp collars and jerseys. Fabric sourcing, sampling, print and embroidery development, and bulk manufacturing at scale.", "Base Layers": "Base layer and knit development — thermals, ribbed sets, performance fabrics and next-to-skin constructions. Fabric selection, fit engineering and production for lifestyle, sport and uniform programs."};
  const CATS = [
    ['Headwear', BRDG.headwear || []],
    ['Outerwear', BRDG.parchive.outerwear || []],
    ['Bottoms', BRDG.parchive.bottoms || []],
    ['Hoodies', BRDG.parchive.hoodies || []],
    ['Jerseys', BRDG.parchive.jerseys || []],
    ['Shirts', BRDG.parchive.shirts || []],
    ['Base Layers', BRDG.parchive.baselayers || []]
  ];
  const ALL = [];
  CATS.forEach(cc => cc[1].forEach(u => ALL.push(u)));
  CATS.forEach(([label, list], ci) => {
    const lab = document.createElement('div');
    lab.className = 'pa-cat'; lab.id = 'pacat-' + ci;
    lab.textContent = '0' + (ci + 1) + ' — ' + label;
    grid.appendChild(lab);
    const cp = document.createElement('p');
    cp.className = 'pa-copy';
    cp.textContent = COPY[label] || '';
    grid.appendChild(cp);
    const mas = document.createElement('div');
    mas.className = 'masonry';
    list.forEach(u => {
      const img = document.createElement('img');
      img.src = u; img.loading = 'lazy'; img.draggable = false;
      img.addEventListener('click', () => openLightbox(ALL, ALL.indexOf(u)));
      mas.appendChild(img);
    });
    grid.appendChild(mas);
  });
})();
/* ===== v45: archive sort ===== */
function paJump(i) {
  const el = document.getElementById('pacat-' + i);
  document.body.classList.remove('pasort-open');
  if (!el) return;
  let n = 0;
  const t = setInterval(() => { el.scrollIntoView({ block:'start' }); if (++n >= 9) clearInterval(t); }, 150);
}
(function(){
  const b = document.getElementById('pasort');
  if (!b) return;
  b.addEventListener('click', e => { e.stopPropagation(); if (document.body.classList.contains('mnav-open')) { document.body.classList.remove('mnav-open'); if (window._syncSort) _syncSort(); } document.body.classList.toggle('pasort-open'); });
  document.addEventListener('click', e => { if (!e.target.closest('#pasortpop') && !e.target.closest('#pasort')) document.body.classList.remove('pasort-open'); });
})();

/* ===== v38: partnership progression scroll reveal ===== */
(function(){
  const pt = document.querySelector('.ptable');
  if (!pt) return;
  if (!('IntersectionObserver' in window)) { pt.classList.add('pt-in'); return; }
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { pt.classList.add('pt-in'); io.disconnect(); } }), { threshold: 0.25 });
  io.observe(pt);
})();
/* ===== v39: work-page Return — landing pages go home, sub-pages go back ===== */
(function(){
  const bt = document.getElementById('backtool');
  if (!bt || !document.getElementById('view-work')) return;
  bt.onclick = () => {
    const v = currentView();
    const rdr = document.getElementById('solreader');
    if (v === 'solutions' && rdr && rdr.classList.contains('open')) { closeReader(); return; }
    if (v === 'work' || v === 'parchive' || v === 'solutions') { location.href = '/'; return; }
    goBack();
  };
})();
/* ===== v38: wand star trail (desktop) ===== */
(function(){
  if (!matchMedia('(pointer:fine)').matches) return;
  let last = 0;
  const SY = ['✦','✧','✶'];
  addEventListener('pointermove', e => {
    const now = performance.now();
    if (now - last < 45) return; last = now;
    const s = document.createElement('span');
    s.className = 'stardust';
    s.textContent = SY[(Math.random() * SY.length) | 0];
    const a = Math.random() * 6.28, d = 6 + Math.random() * 16;
    s.style.left = (e.clientX + Math.random() * 10 - 5) + 'px';
    s.style.top = (e.clientY + Math.random() * 10 - 5) + 'px';
    s.style.setProperty('--dx', (Math.cos(a) * d).toFixed(0) + 'px');
    s.style.setProperty('--dy', (Math.sin(a) * d + 14).toFixed(0) + 'px');
    s.style.fontSize = (7 + Math.random() * 8) + 'px';
    document.body.appendChild(s);
    setTimeout(() => s.remove(), 1300);
  }, { passive:true });
})();

/* ===== v39: solutions reader ===== */
const SOLKEYS = ['design','development','manufacturing','logistics','campaigns','programs','brand','advisory'];
let _lastCat = 0;
function enterReader(i) {
  const r = document.getElementById('solreader');
  if (!r) return;
  _lastCat = i;
  if (!document.getElementById('view-solutions').classList.contains('active')) go('solutions');
  r.classList.add('open');
  const _cu = document.getElementById('srcue'); if (_cu) _cu.classList.remove('gone');
  const _cm = document.getElementById('chmark'); if (_cm) _cm.textContent = ['DESIGN','DESIGN','PRODUCE','PRODUCE','LAUNCH','LAUNCH','SCALE','SCALE'][i];
  r.style.scrollBehavior = 'auto';
  requestAnimationFrame(() => {
    const p = r.querySelector('.solpanel[data-cat="' + i + '"]');
    if (p) r.scrollTop = p.offsetTop;
    r.style.scrollBehavior = 'smooth';
  });
  try { if (_onCapPage) history.replaceState(null, '', _capURL(i)); else history.replaceState(null, '', '#' + SOLKEYS[i]); } catch(e) {}
}
function closeReader() {
  const r = document.getElementById('solreader');
  if (!r) return;
  r.classList.remove('open');
  try { history.replaceState(null, '', _onCapPage ? '/pages/capabilities' : location.pathname); } catch(e) {}
  const row = document.querySelector('.solrow[data-cat="' + _lastCat + '"]');
  if (row) row.scrollIntoView({ block: 'center' });
}
let _readerFromIndex = false;
const _onCapPage = /\/pages\/(capabilities|solutions)/.test(location.pathname);
function _capURL(i) { return '/pages/capabilities-' + SOLKEYS[i]; }
document.querySelectorAll('.solrow').forEach(el => el.addEventListener('click', e => {
  e.preventDefault();
  _readerFromIndex = true;
  enterReader(+el.dataset.cat);
}));
(function(){
  const r = document.getElementById('solreader');
  if (!r) return;
  r.addEventListener('scroll', () => {
    _lastCat = Math.max(0, Math.min(7, Math.round(r.scrollTop / innerHeight)));
    const cu = document.getElementById('srcue'); if (cu && r.scrollTop > 60) cu.classList.add('gone');
    const cm = document.getElementById('chmark'); if (cm) cm.textContent = ['DESIGN','DESIGN','PRODUCE','PRODUCE','LAUNCH','LAUNCH','SCALE','SCALE'][_lastCat];
    clearTimeout(window._capT); window._capT = setTimeout(() => { try { if (_onCapPage && r.classList.contains('open')) history.replaceState(null, '', _capURL(_lastCat)); } catch(e) {} }, 180);
  }, { passive:true });
})();

const PSTMT = ["Drumatized reached out to us to help them bring to life a collaboration between TayKeith and the Memphis Grizzlies. This partnership was released as a game exclusive and a simultaneous online drop. We owned product development, production, and freight forwarding for this partnership and delivered items to the stadium shop floor weeks before the launch.", "This one started before the product did. We introduced our client Half Evil to our NBA partners and structured and managed the collaboration. Half Evil designed the goods and passed us the sketches; we handled product development, bulk production, and freight forwarding for 7 styles from sketch to delivery. We are always working to help our partners and clients create moments in culture and community.", "A limited edition collaboration collection for Guapi × NBA YoungBoy. We owned sourcing, technical design, product development, bulk production and freight forwarding for 29 total garments developed.", "In 2024, with ambition and a blank canvas, our client wanted to build a luxury house and hadn't yet identified Paris Fashion Week as the destination. We named it, then spent two years building a brand that could stand on that runway. We designed the collection, built and fully staffed a dedicated sample room in Los Angeles, and ran development and production through Italian manufacturers. We recruited the team, selected the vendors, and handed each relationship over to the client once it was up and running. The SS27 collection walked in Paris and was covered by sixteen publications. A full-circle moment for the two years of work in helping our client build the foundation to bring the vision to life.", "A limited edition collaboration collection for NFL & Born X Raised. We owned sourcing, technical design, product development, bulk production and freight forwarding for 10 total garments developed.", "This campaign required a full production that would work for both photo and video teams within a set timeframe the location was booked for, so the flow of this day shoot was very important. We assembled a team of six across photo, video, styling, lighting and assist, plus a group of eight models to play as a family — production, creative direction, casting, permits, styling, and shoot production.", "A limited edition six-garment collaboration between Guapi and Dodge built around illuminated fabric. The mill's existing light-up textile wasn't engineered for jacket construction, so we developed a reinforced version and prototyped it before committing. Because the finished garments contain electronics, we also cleared them for international transport and handled the accompanying documentation. We also developed high-quality leather goods for a jacket that was later sold at auction. Technical design, sampling, bulk, and freight were ours.", "Private one-of-one and limited-run product programs developed for artists, athletes, talent, and cultural figures. We handle the full design-to-delivery of bespoke items as their own individual programs. Built around performances, appearances, competition, press, and defining moments.", "A limited edition collaboration collection for the Raiders & Born X Raised. We owned sourcing, technical design, product development, bulk production and freight forwarding for 8 total garments developed.", "A campaign for StreetMob Records shot for photo and video simultaneously, in a booked location with a fixed window. Five models, a seven-person crew across photo, video, styling, lighting, and assist, and a schedule written to the hour. We directed, cast, styled, and produced it, and delivered campaign, motion, and ecommerce in one day.", "Haney's team hired us to build the apparel he and his corner would wear through fight week — weigh-in, walk, and ringside. We designed it with them in person across multiple rounds of drafts, then cut, sewed, printed, and produced the entire run in Los Angeles: tracksuits and sweatsuits for the fight team and screen-printed tees for public sale. We also designed and produced his collaboration program with C4 — tees, towels, and headwear. Finished goods were delivered to Las Vegas the week before the fight date.", "A three-pack accessories program — cotton tanks and underwear — with custom labeling and packaging, contracted against a holiday delivery date. The client supplied reference sketches. We handled fit, technical packages, and the labeling and packaging development from there. Five weeks from sample to delivered bulk.", "Charlo's team came to us to design and produce what he and his corner would wear for a Showtime pay-per-view card weigh-in, walk, and ringside, plus merchandise for the public. Five tee designs, a tracksuit, and two sweatsuits, cut and sewn, screen printed, sampled, and produced in Los Angeles. Delivered in Las Vegas the week of the fight."];
const PTAGS = [["Technical design", "Tech pack development", "Sample development", "Factory sourcing", "PO and production management", "In-line & final inspection", "International freight"], ["Licensed programs", "Capsules & collaborations", "Technical design", "Tech pack development", "Sample development", "PO and production management", "In-line & final inspection", "International freight"], ["Hardware & trim design", "Fabric & material sourcing", "Prototyping", "Product development", "PO and production management", "Freight forwarding", "Bulk production"], ["Brand strategy", "Positioning", "Collection design", "Line planning", "Technical design", "Sample development", "Factory sourcing", "Production calendar management", "Full brand launch", "Embedded creative & production teams", "Vendor selection", "Recruiting & placement"], ["Technical design", "Product development", "Bulk production", "Freight forwarding"], ["Creative direction", "Casting", "Location scouting & permits", "Styling", "Photography & motion", "Lighting", "Post-production & retouching", "Ecommerce and lookbook imagery"], ["Hardware & trim design", "Fabric & material sourcing", "Prototyping", "Product development", "PO and production management", "Freight forwarding", "Bulk production"], ["Creative direction", "Technical design", "Wardrobe program", "Fit engineering", "Tech pack development", "Prototyping", "Sample development", "Embedded creative & production teams", "Final-mile"], ["Technical design", "Product development", "Bulk production", "Freight forwarding"], ["Creative direction", "Casting", "Location scouting & permits", "Styling", "Photography & motion", "Lighting", "Post-production & retouching", "Ecommerce and lookbook imagery"], ["Creative direction", "Graphic & print design", "Licensed and collaboration design", "Tech pack development", "Pattern making", "Sample development", "PO and production management", "Final-mile"], ["Technical design", "Fit standards", "Tech pack development", "Packaging & labeling", "Sample development", "PO and production management"], ["Creative direction", "Graphic & print design", "Tech pack development", "Pattern making", "Sample development", "PO and production management", "In-line & final inspection", "Final-mile"]];

const POUT = ["7 garments developed · Licensed collaboration apparel program A–Z", "7 styles produced in bulk · Licensed collaboration", "29 garments developed · Collaboration collection", "2 years, concept to runway · SS27 shown in Paris · Covered by 16 publications", "10 garments developed · Licensed collaboration", "1-day shoot · 6 crew · 8 models · Photo & video", "6 garments developed · Illuminated fabric R&D", "", "8 garments developed · Licensed collaboration", "1-day shoot · 7 crew · 5 models · Campaign, motion & ecommerce", "Fight-week program + C4 collaboration · Produced in Los Angeles", "3-pack accessories program · 5 weeks, sample to delivered bulk", "8 styles · Cut, sewn & printed in Los Angeles · Delivered fight week"];

/* ===== v49: capability pages boot ===== */
(function(){
  const vs = document.getElementById('view-solutions');
  if (vs) {
    const k = vs.dataset.capstart;
    if (k && k !== 'index' && typeof SOLKEYS !== 'undefined') {
      const i = SOLKEYS.indexOf(k);
      if (i >= 0) setTimeout(() => { _readerFromIndex = false; enterReader(i); }, 0);
    }
  }
  if (document.getElementById('view-work') && location.hash) {
    const h = location.hash.slice(1);
    if (typeof SOLKEYS !== 'undefined' && SOLKEYS.indexOf(h) >= 0) { location.replace('/pages/capabilities-' + h); return; }
    if (h === 'highlights') setTimeout(() => { go('work', false); workMode('projects'); }, 0);
  }
  const bt = document.getElementById('backtool');
  if (bt && document.getElementById('view-solutions') && !document.getElementById('view-work')) {
    bt.onclick = () => {
      const r = document.getElementById('solreader');
      if (r && r.classList.contains('open') && _readerFromIndex) { closeReader(); return; }
      if (history.length > 1 && document.referrer && document.referrer.indexOf(location.host) !== -1) { history.back(); return; }
      location.href = '/';
    };
  }
})();
